import React from 'react';
import Search from '../components/Search';

const SearchMentors = () => (
    <>
        <Search />
    </>
);

export default SearchMentors;